/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetDefaultLicenseDataModules$Request {
    licenseTypeCode?: string;
}

export interface GetDefaultLicenseDataModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDefaultLicenseDataModulesRequest = createAction<PayloadData<void, GetDefaultLicenseDataModules$Request>>('GET_DEFAULT_LICENSE_DATA_MODULES__GET_DEFAULT_LICENSE_DATA_MODULES__REQUEST');
export const getDefaultLicenseDataModulesSuccess = createAction<PayloadData<Array<string>, GetDefaultLicenseDataModules$Request>>('GET_DEFAULT_LICENSE_DATA_MODULES__GET_DEFAULT_LICENSE_DATA_MODULES__SUCCESS');
export const getDefaultLicenseDataModulesFailure = createAction<PayloadData<Error, GetDefaultLicenseDataModules$Request, true>>('GET_DEFAULT_LICENSE_DATA_MODULES__GET_DEFAULT_LICENSE_DATA_MODULES__FAILURE');

export const getDefaultLicenseDataModulesActions = [
    getDefaultLicenseDataModulesRequest,
    getDefaultLicenseDataModulesSuccess,
    getDefaultLicenseDataModulesFailure
] as const;

/**
 * @param {string} [meta.licenseTypeCode] License Type Code
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDefaultLicenseDataModules = (meta: GetDefaultLicenseDataModules$Request, config?: GetDefaultLicenseDataModules$Config) => {
    const TRANSPORT_GET_PARAMS = {
        licenseTypeCode: meta.licenseTypeCode,
    };
    return {
        CALL_API: {
            types: getDefaultLicenseDataModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/license-data-modules/default`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

